import React from 'react';
import { string, shape, arrayOf, bool } from 'prop-types';

import { useBLazyRevalidate } from 'hooks';
import { TradeShowCard } from 'components/cards';
import { LISTING_CONTAINER_ID } from '../constants';

const TradeShowsListing = ({ items }) => {
    useBLazyRevalidate(LISTING_CONTAINER_ID, [items]);

    if (!items || !items.length) {
        return null;
    }

    return (
        <div className="c-listing__trade-shows">
            {items.map(item => (
                <TradeShowCard {...item} key={item.id} />
            ))}
        </div>
    );
};

TradeShowsListing.propTypes = {
    items: arrayOf(
        shape({
            appointmentButton: shape({
                title: string,
                email: string,
                disabled: bool
            }),
            date: string,
            description: string,
            id: string,
            image: shape({
                url: string,
                alt: string
            }),
            info: string,
            link: shape({
                title: string,
                url: string,
                target: string,
                disabled: bool
            }),
            location: string,
            title: string
        })
    ).isRequired
};

export default TradeShowsListing;
